define("shared/errors/credentials", ["exports", "@ember/debug", "shared/utils/errors/define-error"], function (_exports, _debug, _defineError) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.CredentialsNotFoundError = _exports.CredentialsMissingPermissionsError = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"shared/utils/errors/define-error"eaimeta@70e063a35619d71f
  const CredentialsNotFoundError = _exports.CredentialsNotFoundError = (0, _defineError.defineError)({
    name: 'CredentialsNotFound',
    message: 'Credentials Not Found',
    resolve: function handleCredentialsNotFound(socialProfile, source) {
      if (!this.router) {
        (0, _debug.debug)('Context is missing injection for router service');
        return;
      }
      if (this.auth.currentGroup) {
        this.router.transitionTo('account.groups.group.social_profiles.index', this.auth.currentGroup.get('id'), {
          queryParams: {
            profile: socialProfile.get('id'),
            showCredentialsWizard: true,
            source
          }
        });
        return;
      }
    }
  });
  const CredentialsMissingPermissionsError = _exports.CredentialsMissingPermissionsError = (0, _defineError.defineError)({
    name: 'CredentialsMissingPermissions',
    message: 'CredentialsMissingPermissions',
    resolve: function handleCredentialsMissingPermissions(allScopes) {
      if (!this.errors) {
        (0, _debug.debug)('Context is missing injection for errors service');
      } else {
        this.errors.log('Credentials Missing Permissions', allScopes);
      }
      this.setProperties({
        missingScopes: true,
        currentModal: 'missingPermissions'
      });
    }
  });
});